import { PropsWithChildren } from 'react';

import { UserContext } from './AuthUserContext';
import { User, UserInfo } from './types';

export const ONCI_USER: User = {
  userId: 'd47e8ae0-6dbf-4fef-ae60-c658ddd13e59',
  tenantId: 'ff3e467e-8bc1-4ee2-ad95-432ad47de022',
  isONUser: true,
  tenantName: 'Random Bank',
  firstName: 'ONCI',
  lastName: 'User',
  email: 'on.user@test.com',
};

export const CLIENT_USER: User = {
  userId: '3f26cfdf-3615-4040-8df2-21b9d7fdbb12',
  tenantId: 'ff3e467e-8bc1-4ee2-ad95-432ad47de022',
  isONUser: false,
  tenantName: 'Random Bank',
  firstName: 'Client',
  lastName: 'User',
  email: 'client.user@test.com',
};

export function TestUserContextProvider({ children, value }: PropsWithChildren<{ value?: UserInfo }>) {
  return (
    <UserContext.Provider
      value={
        value
          ? value
          : {
              user: CLIENT_USER,
              accessToken: '1111',
              onLogout: () => console.debug('Logout'),
            }
      }
    >
      {children}
    </UserContext.Provider>
  );
}
